export const ORDER_REQUESTS_CONSTS = {
    GET_ORDER_REQUESTS: "GET_ORDER_REQUESTS",
    DELETE_ORDER_REQUEST_BY_ID: "DELETE_ORDER_REQUEST_BY_ID",
};
